import { render, staticRenderFns } from "./CompanyLegalStatusSelect.vue?vue&type=template&id=60a3972a&scoped=true&"
import script from "./CompanyLegalStatusSelect.vue?vue&type=script&lang=ts&"
export * from "./CompanyLegalStatusSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a3972a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
